import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import ColumnsLayout from '../../../pages/Layout/ColumnsLayout';
import { TradeContext, TradeState } from '../../../_shared/types/trade';
import PendingDecision from '../PendingDecision';
import PendingNegotiations from '../PendingNegotiations';
import NegotiationDisclaimer from './Styles';
import useTradeSort from '../../../_shared/hooks/trade/sort/useTradeSort';
import TradeFilterBar from '../../TradeFilterBar';
import TradeListFooter from '../../TradeList/TradeListFooter';
import TradeListHeader from '../../TradeList/TradeListHeader';
import Reducers from '../../../_shared/constants/reducers';

const PendingContainer = ({
  tradeContext,
  isOmp = false,
  handleNavigateToTradeUri
}) => {
  const tradeState = TradeState.pending;
  const filtersButtonRef = useRef(null);
  const [hasNetwork, setHasNetwork] = useState(true);
  const setSortOption = useTradeSort();
  const [showFooter, activeNetwork, selectedSortOption] = useSelector(
    state => [
      state[Reducers.PENDING_STATE]?.showFooter,
      state?.filter?.activeNetwork?.[tradeState],
      state?.ui?.tradeSort?.[tradeState]
    ],
    shallowEqual
  );

  const getFilterBar = () => {
    return (
      hasNetwork && (
        <TradeFilterBar
          selectedSortOption={selectedSortOption}
          setSortOption={setSortOption}
          tradeState={tradeState}
          filtersButtonRef={filtersButtonRef}
          setHasNetwork={setHasNetwork}
          showLayoutToggle={false}
          showSortOptions={false}
          isOmp={isOmp}
        />
      )
    );
  };
  const getFooter = () => {
    return (
      showFooter && (
        <TradeListFooter
          tradeState={tradeState}
          activeNetwork={activeNetwork}
          isOmp={isOmp}
          handleNavigateToTradeUri={handleNavigateToTradeUri}
        />
      )
    );
  };
  const getDisclaimer = () => {
    const showDisclaimer = tradeContext === TradeContext.Sell;
    return (
      showDisclaimer && (
        <NegotiationDisclaimer>
          <FormattedMessage id="negotiation.free.disclaimer" />
        </NegotiationDisclaimer>
      )
    );
  };

  const getHeader = () => {
    return <TradeListHeader tradeState={tradeState} />;
  };

  return (
    <ColumnsLayout
      header={getHeader()}
      disclaimer={getDisclaimer()}
      filterBar={getFilterBar()}
      columns={[
        <PendingDecision
          tradeContext={tradeContext}
          activeNetwork={activeNetwork}
          isOmp={isOmp}
          handleNavigateToTradeUri={handleNavigateToTradeUri}
        />,
        <PendingNegotiations
          tradeContext={tradeContext}
          activeNetwork={activeNetwork}
          isOmp={isOmp}
          handleNavigateToTradeUri={handleNavigateToTradeUri}
        />
      ]}
      footer={getFooter()}
    />
  );
};

export default PendingContainer;
